<template>
  <div>
    <v-card class="main-container">
      <v-card-title style="color:gray; font-weight:bold; padding-left: 0px;">

        <v-chip v-if="view_type=='moderator'"
          color="#16336e"
          dark
          class="new-proposal"
          @click="new_council()">
          <v-icon small class="ma-1">mdi-plus-box</v-icon> 
          Новый совет
        </v-chip>

        <div style="width: 1000px; margin-left: 20px;">

          <v-tabs v-model="activeTab">
            <v-tab
              exact-active-class="custom-color"
              v-for="(item, i) in statusList"
              :key="i"
              :style="{color: $mainColor + ' !important', caretColor: $mainColor + ' !important'}">
                  {{item.name}}
            </v-tab>
          </v-tabs>
        </div>
      </v-card-title>

      <v-card-text>
        <v-tabs-items>
          <v-data-table
            :style="{color: $mainColor}"
            :headers="current_headers"
            :items="listCouncils"
            :loading="preloaderYet"
            :loading-text="$t('User.loading_orders')"
            :items-per-page="10"
            :footer-props="{
                itemsPerPageOptions: [10, 20, 50],
                itemsPerPageText: 'кол-во на стр.:',
            }"
          >
            <template v-slot:item.id="{ item }">
              <span @click="openDetailInfo(item.id)" style="cursor: pointer;">
                {{ item.id }}
              </span>
            </template>
            <template v-slot:item.name="{ item }">
              <v-tooltip v-if="item.last_status_id == 1" right>
                  <span>{{$t('need_modification')}}</span>
              </v-tooltip>
              <span @click="openDetailInfo(item.id)" style="cursor: pointer;">
                {{ item.name ? item.name: $t('untitled') }}
              </span>
            </template>
            <template v-slot:item.date="{ item }" >
              <span @click="openDetailInfo(item.id)" style="cursor: pointer;">
                {{g.toDate(item.date)}}
              </span>  
            </template>
            <template v-slot:item.create_date="{ item }" >
              {{g.toDate(item.create_date)}}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon
                v-if="statusList[activeTab].status_id === 0"
                class="ma-2"
                small
                color="red lighten-1"
                @click="dialogConfirmDelete = true; delete_id = item.id">
                mdi-delete
              </v-icon>
              <v-icon
                v-if="statusList[activeTab].status_id === 4"
                class="ma-2"
                small
                color="red lighten-1"
                @click="dialogConfirmReturn = true; delete_id = item.id">
                mdi-undo-variant
              </v-icon>
            </template>
          </v-data-table>
        </v-tabs-items>            
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogConfirmDelete" persistent max-width="520px">
      <v-card>
        <v-card-title class="headline">{{$t('Actions.confirmation')}}</v-card-title>
        <v-card-text>Вы действительно хотите удалить совет # {{ delete_id }}</v-card-text>
        <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" outlined :color="$mainColor" @click="dialogConfirmDelete = false">{{$t('cancel')}}</v-btn>
        <v-btn color="green darken-1" outlined :color="$mainColor" @click="dialogConfirmDelete = false, deleteCouncil(delete_id)">удалить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirmReturn" persistent max-width="520px">
      <v-card>
        <v-card-title class="headline">{{$t('Actions.confirmation')}}</v-card-title>
        <v-card-text>Вы действительно хотите вернуть совет в статус черновик  # {{ delete_id }}</v-card-text>
        <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" outlined :color="$mainColor" @click="dialogConfirmReturn = false">{{$t('cancel')}}</v-btn>
        <v-btn color="green darken-1" outlined :color="$mainColor" @click="dialogConfirmReturn = false, returnCouncil(delete_id)">вернуть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

          <!-- диалог карточки -->
    <v-dialog v-model="dialogCouncilCard"  max-width="90%">
      <council-modal-card
        :page_editable="editable"
        @closeCouncilDialog="dialogCouncilCard=false"
        @updateParent="update_parent($event.item, $event.close_modal)"
        @deleteCouncil="deleteCouncil($event.item)"
      />
    </v-dialog>


    <v-dialog v-model="new_council_dialog" persistent max-width="800px">
      <v-card>
        <v-card-title class="headline">Создание нового экспертного совета
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="new_council_name"
                outlined
                required
                name="input-7-4"
                label="Номер заседания"
                :error="error_new_council_name"
                solo
                @input="new_council_name.length > 0 ? error_new_council_name = false : error_new_council_name = true"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-menu
                v-model="MenuCouncil"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                :error="error_new_council_date"
                max-width="290px"
                min-width="auto">
                <template v-slot:activator="{ on }">
                  <v-text-field

                    v-model="computedCouncilDate"
                    label="Дата очной части совета"
                    hint="Дата очной части совета"
                    persistent-hint
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    solo
                    :error="error_new_council_date"
                    ></v-text-field>
                </template>
                <v-date-picker
                  v-model="new_council_date" 
                  no-title
                  scrollable
                  @input="MenuCouncil = false"
                  first-day-of-week="1"
                  locale='ru-RU'
                  :allowed-dates="allowedDates"
                  min="2024-12-01"
                  :error="error_new_council_date"
                  ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4" class="pa-0 pl-3">
              <v-checkbox
                v-model="new_council_is_si"
                label="КИСИ"
                :error="error_new_council_is_si"
                @input="validate_new_council_save()"
              ></v-checkbox>
            </v-col>
            <v-col cols="8" class="pa-0 pr-3">
              <v-text-field
                v-if="new_council_is_si"
                v-model="new_council_si_session_name"
                counter
                maxlength="30"
                outlined
                required
                label="Название сессии"
                :error="error_new_council_is_si"
                @input="validate_new_council_save()"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="new_council_is_si">
            <v-col cols="4" offset="4" class="pa-0 pl-3">
              <v-menu
                v-model="siMenuStart"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
                :error="error_new_council_is_si"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="computedDateSiStart"
                    label="сессия с"
                    hint="период планирования"
                    persistent-hint
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    solo
                    :error="error_new_council_is_si"
                    ></v-text-field>
                </template>
                <v-date-picker
                  v-model="new_council_si_date_start" 
                  no-title
                  scrollable
                  @input="siMenuStart = false"
                  first-day-of-week="1"
                  locale='ru-RU'
                  min="2024-12-01"
                  :error="error_new_council_is_si"
                  ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="4" class="pa-0 pl-2 pr-3">
              <v-menu
                v-model="siMenuEnd"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                :error="error_new_council_is_si"
                max-width="290px"
                min-width="auto">
                <template v-slot:activator="{ on }">
                  <v-text-field

                    v-model="computedDateSiEnd"
                    label="сессия по"
                    persistent-hint
                    readonly
                    v-on="on"
                    solo
                    color="red"
                    :error="error_new_council_is_si"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="new_council_si_date_end" 
                  no-title
                  scrollable
                  @input="siMenuEnd = false"
                  first-day-of-week="1"
                  locale='ru-RU'
                  min="2024-12-01"
                  :error="error_new_council_is_si"
                ></v-date-picker>
              </v-menu>

            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4" class="pa-0 pl-3">
              <v-checkbox
                v-model="new_council_is_ir8"
                label="ИР-8"
                :error="error_new_council_is_ir8"
                @input="validate_new_council_save()"
              ></v-checkbox>
            </v-col>
            <v-col cols="8" class="pa-0 pr-3">
              <v-text-field
                v-if="new_council_is_ir8"
                v-model="new_council_ir8_session_name"
                counter
                maxlength="30"
                outlined
                required
                label="Название сессии"
                :error="error_new_council_is_ir8"
                @input="validate_new_council_save()"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="new_council_is_ir8">
            <v-col cols="4" offset="4" class="pa-0 pl-3">
              <v-menu
                v-model="ir8MenuStart"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                :error="error_new_council_is_ir8"
                max-width="290px"
                min-width="auto">
                <template v-slot:activator="{ on }">
                  <v-text-field

                    v-model="computedDateIr8Start"
                    label="сессия с"
                    hint="период планирования"
                    persistent-hint
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    solo
                    :error="error_new_council_is_ir8"
                    ></v-text-field>
                </template>
                <v-date-picker
                  v-model="new_council_ir8_date_start" 
                  no-title
                  scrollable
                  @input="ir8MenuStart = false"
                  first-day-of-week="1"
                  locale='ru-RU'
                  min="2024-12-01"
                  :error="error_new_council_is_ir8"
                  ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="4" class="pa-0 pl-2 pr-3">
              <v-menu
                v-model="ir8MenuEnd"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                :error="error_new_council_is_ir8"
                max-width="290px"
                min-width="auto">
                <template v-slot:activator="{ on }">
                  <v-text-field

                    v-model="computedDateIr8End"
                    label="сессия по"
                    persistent-hint
                    readonly
                    v-on="on"
                    solo
                    :error="error_new_council_is_ir8"
                    ></v-text-field>
                </template>
                <v-date-picker
                  v-model="new_council_ir8_date_end" 
                  no-title
                  scrollable
                  @input="ir8MenuEnd = false"
                  first-day-of-week="1"
                  locale='ru-RU'
                  min="2024-12-01"
                  :error="error_new_council_is_ir8"
                  ></v-date-picker>
              </v-menu>

            </v-col>
          </v-row>

          <v-row>
            <v-col cols="4" class="pa-0 pl-3">
              <v-checkbox
                v-model="new_council_is_lab"
                label="Лаб.приборы"
                :error="error_new_council_is_lab"
                @input="validate_new_council_save()"
              ></v-checkbox>
            </v-col>
            <v-col cols="8" class="pa-0 pr-3">
              <v-text-field
                v-if="new_council_is_lab"
                v-model="new_council_lab_session_name"
                counter
                maxlength="30"
                outlined
                required
                label="Название сессии"
                :error="error_new_council_is_lab"
                @input="validate_new_council_save()"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="new_council_is_lab">
            <v-col cols="4" offset="4" class="pa-0 pl-3">
              <v-menu
                v-model="labMenuStart"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                :error="error_new_council_is_lab"
                max-width="290px"
                min-width="auto">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="computedDateLabStart"
                    label="сессия с"
                    hint="период планирования"
                    persistent-hint
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    solo
                    :error="error_new_council_is_lab"
                    ></v-text-field>
                </template>
                <v-date-picker
                  v-model="new_council_lab_date_start" 
                  no-title
                  scrollable
                  @input="labMenuStart = false"
                  first-day-of-week="1"
                  locale='ru-RU'
                  min="2024-12-01"
                  :error="error_new_council_is_lab"
                  ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="4" class="pa-0 pl-2 pr-3">
              <v-menu
                v-model="labMenuEnd"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                :error="error_new_council_is_lab"
                max-width="290px"
                min-width="auto">
                <template v-slot:activator="{ on }">
                  <v-text-field

                    v-model="computedDateLabEnd"
                    label="сессия по"
                    persistent-hint
                    readonly
                    v-on="on"
                    solo
                    :error="error_new_council_is_lab"
                    ></v-text-field>
                </template>
                <v-date-picker
                  v-model="new_council_lab_date_end" 
                  no-title
                  scrollable
                  @input="labMenuEnd = false"
                  first-day-of-week="1"
                  locale='ru-RU'
                  min="2024-12-01"
                  :error="error_new_council_is_lab"
                  ></v-date-picker>
              </v-menu>

            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="new_council_dialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="green darken-1" text
            @click="new_council_save()">{{"Создать"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import councilModalCard from './modalCard.vue';

export default {
  name: 'councilList',
  components: {
    councilModalCard,
  },
  props: {
    view_type: String,
  },

  data() {
    return {
      dialogCouncilCard: false,
      listCouncils: [],
      preloaderYet: false,
      current_index: 0,
      delete_id: null,
      dialogConfirmDelete: false,
      dialogConfirmReturn: false,

      error_new_council_date: false,
      error_new_council_name: false,
      error_new_council_is_si: false,
      error_new_council_is_lab: false,
      error_new_council_is_ir8: false,

      new_council_dialog: false,
      new_council_date: null,
      new_council_name: '',
      new_council_is_lab: false,
      new_council_is_ir8: false,
      new_council_is_si: false,
      new_council_si_date_start: null,
      new_council_si_date_end: null,
      new_council_ir8_date_start: null,
      new_council_ir8_date_end: null,
      new_council_lab_date_start: null,
      new_council_lab_date_end: null,
      new_council_si_session_name: null,
      new_council_ir8_session_name: null,
      new_council_lab_session_name: null,
      siMenuStart: false,
      siMenuEnd: false,
      ir8MenuStart: false,
      ir8MenuEnd: false,
      labMenuStart: false,
      labMenuEnd: false,

      MenuCouncil: false,

      activeTab: 0,
      statusList: [],

      moderatorStatusList: [
          { status_id: 0, name: 'Черновики'},
          { status_id: 1, name: 'Запланированы'},
          { status_id: 2, name: 'В рассмотрении'},
          { status_id: 5, name: 'В планировании'},
          { status_id: 3, name: 'Проведены'},
          { status_id: 4, name: 'Отменены'},
      ],
      expertStatusList: [
          { status_id: 1, name: 'Запланированы'},
          { status_id: 2, name: 'В рассмотрении'},
          { status_id: 5, name: 'В планировании'},
          { status_id: 3, name: 'Проведены'},
      ],
      current_headers: [],
      headers_base: [
          { text: 'ID', sortable: true, value: 'id'},
          { text: 'Дата', sortable: true, value: 'date'},
          { text: 'Номер заседания', sortable: true, value: 'name'},
          { text: 'Кол-во заявок', sortable: false, value: 'proposal_count'},
          { text: 'Дата создания', sortable: true, value: 'create_date'},
      ],
      headers_action: [
          { text: 'ID', sortable: true, value: 'id'},
          { text: 'Дата', sortable: true, value: 'date'},
          { text: 'Номер заседания', sortable: true, value: 'name'},
          { text: 'Кол-во заявок', sortable: false, value: 'proposal_count'},
          { text: 'Дата создания', sortable: true, value: 'create_date'},
          { text: this.$t('actions'), value: 'actions', sortable: false}
      ],
      editable: {
        can_edit : false,
        can_export : false,
        can_see_experts: false,
      },

    };
  },

  computed: {
    computedDateSiStart() {
      return this.formatDate(this.new_council_si_date_start);
    },
    computedDateSiEnd() {
      return this.formatDate(this.new_council_si_date_end);
    },
    computedDateIr8Start() {
      return this.formatDate(this.new_council_ir8_date_start);
    },
    computedDateIr8End() {
      return this.formatDate(this.new_council_ir8_date_end);
    },
    computedDateLabStart() {
      return this.formatDate(this.new_council_lab_date_start);
    },
    computedDateLabEnd() {
      return this.formatDate(this.new_council_lab_date_end);
    },

    computedCouncilDate() {
      return this.formatDate(this.new_council_date);
    },
  },

  beforeMount() {
    if(this.view_type == 'moderator'){
      this.statusList = this.moderatorStatusList
      this.current_headers = this.headers_action
      this.editable.can_edit = true
      this.editable.can_export = true
    }
    else if(this.view_type == 'expert'){
      this.statusList = this.expertStatusList
      this.current_headers = this.headers_base
      this.editable.can_edit = false
      this.editable.can_export = true

    }
    else{
      this.statusList = this.expertStatusList
      this.current_headers = this.headers_base
      this.editable.can_edit = false
      this.editable.can_export = true
    }

    this.loadNewRequest();
    this.GET_EXPER();
  },

  methods: {
    ...mapActions([
      'GET_COUNCIL_ALL',
      'GET_LIST_COUNCILS',
      'DELETE_COUNCIL',
      'RETURN_COUNCIL',
      'NEW_COUNCIL',
      'GET_EXPER',
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
    ]),

    // formatDate(date) {
    //   if (!date) return null;
    //   return moment(date).format('L');
    // },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },


    deleteCouncil(id) {
      this.delete_id = id
      this.UPDATE_OVERLAY(true)
      try {
        this.DELETE_COUNCIL({
          deleteId: this.delete_id
        })
        .then((res) => {
          this.UPDATE_OVERLAY(false)
          if(res.status == true){
            this.dialogCouncilCard = false
            this.listCouncils = this.listCouncils.filter(item => item.id !== this.delete_id)
            this.$messageHelper(`Совет № ${this.delete_id} отменен`, 'success', 3000)
          }
          else{
            if(res.error){
              this.$messageHelper(`${this.$t('error_occurred')}: ${res.error}`, 'error', 3000)
            }
            else{
              this.$messageHelper(`${this.$t('error_occurred')}`, 'error', 3000)
            }

          }
        })
      } catch (e) {
        this.UPDATE_OVERLAY(false)
        this.$messageHelper(`${this.$t('error_occurred')}: ${e}`, 'error', 3000)
      }


    },

    returnCouncil(id) {
      this.delete_id = id
      this.UPDATE_OVERLAY(true)
      try {
        this.RETURN_COUNCIL({
          id: this.delete_id
        })
        .then((res) => {
          this.UPDATE_OVERLAY(false)
          if(res.status == true){
            this.listCouncils = this.listCouncils.filter(item => item.id !== this.delete_id)
            this.$messageHelper(`Совет № ${this.delete_id} возвращен в черновики`, 'success', 3000)
          }
          else{
            if(res.errors){
              this.$messageHelper(`${this.$t('error_occurred')}: ${res.errors}`, 'error', 3000)
            }
            else{
              this.$messageHelper(`${this.$t('error_occurred')}`, 'error', 3000)
            }

          }
        })
      } catch (e) {
        this.UPDATE_OVERLAY(false)
        this.$messageHelper(`${this.$t('error_occurred')}: ${e}`, 'error', 3000)
      }


    },

    new_council(){
      this.new_council_dialog = true
      this.new_council_date = null
      this.new_council_name = ''
      this.new_council_is_lab = false
      this.new_council_is_ir8 = false
      this.new_council_is_si = false
      this.new_council_si_date_start = null
      this.new_council_si_date_end = null
      this.new_council_ir8_date_start = null
      this.new_council_ir8_date_end = null
      this.new_council_lab_date_start = null
      this.new_council_lab_date_end = null

    },

    validate_new_council_save() {
      this.error_new_council_name = false
      this.error_new_council_is_si = false
      this.error_new_council_is_lab = false
      this.error_new_council_is_ir8 = false
      this.error_new_council_date = false

      var res = true
      if (!this.new_council_name){
        this.error_new_council_name = true
        res = false
      }
      if(!this.new_council_date){
        this.error_new_council_date = true
        res =false
      }
      if(this.new_council_is_si){
        if(!this.new_council_si_session_name || !this.new_council_si_date_start || !this.new_council_si_date_end){
          this.error_new_council_is_si = true
          res = false
        }
      }
      if(this.new_council_is_lab){
        if(!this.new_council_lab_session_name || !this.new_council_lab_date_start || !this.new_council_lab_date_end){
          this.error_new_council_is_lab = true
          res = false
        }
      }
      if(this.new_council_is_ir8){
        if(!this.new_council_ir8_session_name || !this.new_council_ir8_date_start || !this.new_council_ir8_date_end){
          this.error_new_council_is_ir8 = true
          res = false
        }
      }

      return res
    },

    new_council_save(){
      this.UPDATE_OVERLAY(true)
      if(!this.validate_new_council_save()){
        this.UPDATE_OVERLAY(false)
        return
      }

      var data = {
        date: this.new_council_date.split('.').reverse().join('-'),
        name: this.new_council_name,
        is_lab: this.new_council_is_lab,
        is_ir8: this.new_council_is_ir8,
        is_si: this.new_council_is_si,
        si_session_start: this.new_council_is_si ? this.new_council_si_date_start.split('.').reverse().join('-') : null,
        si_session_end: this.new_council_is_si ? this.new_council_si_date_end.split('.').reverse().join('-') : null,
        ir8_session_start: this.new_council_is_ir8 ? this.new_council_ir8_date_start.split('.').reverse().join('-') : null,
        ir8_session_end: this.new_council_is_ir8 ? this.new_council_ir8_date_end.split('.').reverse().join('-') : null,
        lab_session_start: this.new_council_is_lab ? this.new_council_lab_date_start.split('.').reverse().join('-') : null,
        lab_session_end:  this.new_council_is_lab ? this.new_council_lab_date_end.split('.').reverse().join('-') : null,
        si_session_name: this.new_council_is_si ? this.new_council_si_session_name : null,
        ir8_session_name: this.new_council_is_ir8 ? this.new_council_ir8_session_name : null,
        lab_session_name:  this.new_council_is_lab ? this.new_council_lab_session_name : null,
      }

      try {
          this.NEW_COUNCIL(data)
          .then((res) => {
            this.UPDATE_OVERLAY(false)
            if(res.id > 0){
              this.loadNewRequest(this.current_index)
              this.$messageHelper(`Совет создан`, 'success', 3000)
              this.new_council_dialog = false
            }
            else{
              this.$messageHelper(`${this.$t('error_occurred')}`, 'error', 3000)
            }
          })
      } catch (e) {
          this.UPDATE_OVERLAY(false)
          this.$messageHelper(`${this.$t('error_occurred')}: ${e}`, 'error', 3000)
      }
},

    allowedDates(val){
      return true
      //  return (val >= this.last_status_date)
    },
    
    loadNewRequest(index = 0) {
      this.current_index = index
      this.preloaderYet = true;
      this.listCouncils = [];

      this.GET_LIST_COUNCILS({status_id: this.statusList[index].status_id, view_type: this.view_type})
        .then((res) => {
          this.preloaderYet = false;
          this.listCouncils = res.data;
        })
        .catch(() => this.preloaderYet = false);
    },

    async openDetailInfo(id) {
      this.UPDATE_OVERLAY(true)
      this.GET_COUNCIL_ALL(id)
      .then(() => {
        this.UPDATE_OVERLAY(false)
        this.dialogCouncilCard = true
      })        
    },

    update_parent(item, close_modal = true) {
      if(close_modal)
        this.dialogCouncilCard = false;
      if(item == -1)
        this.loadNewRequest(this.current_index)
      else
        this.listCouncils = this.listCouncils.filter((items) => items.id !== item);
    },
  },

  watch: {
    new_council_si_date_start(val){
      this.validate_new_council_save()
    },

    activeTab(val) {
      this.loadNewRequest(val)
      if(this.statusList[val].status_id == 3 || this.view_type == 'expert')
        this.current_headers = this.headers_base
      else
        this.current_headers = this.headers_action
    },
  },
};
</script>
